import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgArrowOffsite = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path fill="#2D2E2E" d="M5 3H3v18h18v-2H5V3Z" />
    <path
      fill="#2D2E2E"
      d="m12 3-2 2h7.59l-8.3 8.29 1.42 1.42L19 6.41V14l2-2V3h-9Z"
    />
  </svg>
);
export default SvgArrowOffsite;
